import { useMemo } from "react"
import { CacheService } from "../services/cacheService";

export default function useCache() {
    const cache = useMemo(() => {
        return new CacheService();
    }, []);
    
    const getOrCreate = async (key, request, getFunc, expirationMinutes) => {
        return await cache.getOrCreate(key, request, getFunc, expirationMinutes);
    }

    return {
        getOrCreate
    }
}